import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from '@mui/material/styles';
import { AppRoutes } from './routes/AppRoutes';
import { AlertProvider } from './components/molecules/Alerts/AlertContext';
import { theme } from './styles/theme';
console.log(`build: ${process.env.CI_COMMIT_TAG}`);
function App() {
    return (_jsx(ThemeProvider, Object.assign({ theme: theme }, { children: _jsx(AlertProvider, { children: _jsx(AppRoutes, {}) }) })));
}
export default App;
